<script>
	import { projectSettings, acceptedFileUploadList } from "../../config";
	import { pageNumber, model } from "../../stores";
	import DropZone from "../../components/DropZone.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	export let pageIndex = null;
	export let pageTitle = null;
	export let disabled = false;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;
	export let title = null;

	let id = "fileUploader";
	let options = {
		url: "/api/file-upload?token=" + $model.RegistrationToken,
		acceptedFiles: acceptedFileUploadList
	};

	if (!disabled) {
		pageNumber.update((p) => pageIndex);
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	$model.documentList = $model.documentList || [];
</script>

<section>
	{#if !disabled}
		<h1>Supporting Documentation</h1>
		<p>
			Please provide any supporting documents. Supporting documents may include booking details, tax receipts,
			copies of any Princess Cruises catalogues or brochures, or any materials received on boarding the voyage?
		</p>

		<div class="form-row">
			<div class="form-group col-md-12">
				<DropZone
					{options}
					{id}
					message="Drop files here or click to upload for this registration"
					bind:documentList={$model.documentList}
				></DropZone>
			</div>
		</div>

		<div class="form-group form-row">
			<div class="col-md-12 last">
				<NavigationButtons {persistUrl} {previousPage} {nextPage} pageName={title} tealiumTag={true}
				></NavigationButtons>
			</div>
		</div>
	{:else}
		<div class="form-group">
			<h2>Uploaded Documents</h2>

			{#if $model.documentList && $model.documentList.length > 0}
				<table class="table table-sm">
					<tr>
						<th>Document Name</th>
					</tr>
					{#each $model.documentList as file}
						<tr>
							<td>{file.fileName}</td>
						</tr>
					{/each}
				</table>
			{:else}
				<p>No documents uploaded</p>
			{/if}
		</div>
	{/if}
</section>
